import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "sidebar-collapsed"
const AUTO_COLLAPSE_QUERY = "(max-width: 1279px)"
const DEFAULT_EXPANDED_WIDTH = "w-[26rem]"
const COLLAPSED_WIDTH = "w-14"

export default class extends Controller {
  static targets = ["expanded", "minimized", "sidebar", "icon"]
  static values = {
    expandedWidth: { type: String, default: DEFAULT_EXPANDED_WIDTH },
  }

  connect() {
    this.userCollapsed = localStorage.getItem(STORAGE_KEY) === "true"
    this.autoCollapsed = false

    this.mediaQuery = window.matchMedia(AUTO_COLLAPSE_QUERY)
    this.handleMediaChange = this.handleMediaChange.bind(this)
    this.mediaQuery.addEventListener("change", this.handleMediaChange)

    this.handleMediaChange(this.mediaQuery)
  }

  disconnect() {
    this.mediaQuery.removeEventListener("change", this.handleMediaChange)
  }

  handleMediaChange(e) {
    const matches = e.matches !== undefined ? e.matches : e
    if (matches) {
      this.autoCollapsed = true
      this.collapsed = true
    } else {
      this.autoCollapsed = false
      this.collapsed = this.userCollapsed
    }
    this.apply()
  }

  toggle() {
    this.collapsed = !this.collapsed
    this.userCollapsed = this.collapsed
    this.autoCollapsed = false
    localStorage.setItem(STORAGE_KEY, this.collapsed)
    this.apply()
  }

  apply() {
    const expandedWidth = this.expandedWidthValue || DEFAULT_EXPANDED_WIDTH
    if (this.collapsed) {
      this.sidebarTarget.classList.remove(expandedWidth)
      this.sidebarTarget.classList.add(COLLAPSED_WIDTH)
      // Clear any inline width set by resizable-sidebar — an inline style
      // beats the w-14 class, so without this the rail won't collapse.
      this.sidebarTarget.style.width = ""
      this.expandedTargets.forEach((el) => el.classList.add("hidden"))
      if (this.hasMinimizedTarget)
        this.minimizedTarget.classList.remove("hidden")
      if (this.hasIconTarget) this.iconTarget.classList.add("rotate-180")
    } else {
      this.sidebarTarget.classList.remove(COLLAPSED_WIDTH)
      this.sidebarTarget.classList.add(expandedWidth)
      this.expandedTargets.forEach((el) => el.classList.remove("hidden"))
      if (this.hasMinimizedTarget) this.minimizedTarget.classList.add("hidden")
      if (this.hasIconTarget) this.iconTarget.classList.remove("rotate-180")
      // Restore the user's chosen width when the rail re-expands.
      const resizable = this.application.getControllerForElementAndIdentifier(
        this.sidebarTarget,
        "resizable-sidebar",
      )
      if (resizable) resizable.apply()
    }
  }
}
